<template>
  <div class="full">
    <div class="toolbar">
      <div class="tool-list">
        <div class="tool" v-for="tool of toolbar.tools" :key="tool.id" @click.prevent="activeTool = tool.id"
          :data-active="tool.id == activeTool">
          <img class="icon" :src="tool.icon" :alt="tool.label">
          <span class="name">{{ tool.label }}</span>
          <input type="tel" class="tool-size" v-if="tool.id == activeTool && tool.size != null" v-model="tool.size">
          <span class="key" v-if="tool.key">{{ tool.key }}</span>
        </div>
      </div>
    </div>
    <div class="form-pages">
      <div class="form-page" v-for="(pageImage, idx) in pageImages" :key="idx" :style="getPageStyle(pageImage)"
        @mousedown.prevent="handlePageClick($event, idx)" @contextmenu.prevent="">
        <div class="page-annot" v-for="pageAnnot of getPageAnnots(idx)" :key="pageAnnot._id" :data-id="pageAnnot._id"
          :style="getAnnotStyle(pageAnnot)" @mousedown.prevent.stop="handleClickAnnot($event, pageAnnot)"
          :data-selected="isAnnotSelected(pageAnnot)" :data-required="!pageAnnot.optional">
          <span v-if="shouldShowKey(pageAnnot.key)">{{ getFieldLabelForKey(pageAnnot.key) }}</span>
          <span v-else-if="pageAnnot.type == 'DATE'">MM/DD/YYYY</span>
          <span v-else-if="pageAnnot.type == 'PHONE'">(123) 123-1234</span>
          <span v-else-if="pageAnnot.type == 'EMAIL'">example@gmail.com</span>
          <span v-else-if="pageAnnot.type == 'NUMBER'">123</span>
          <span v-else-if="pageAnnot.type == 'SSN'">XXX-XX-XXXX</span>
          <span v-else-if="pageAnnot.type == 'DROPDOWN'">Select...</span>
          <span v-else-if="pageAnnot.type == 'MULTISELECT'">Multi...</span>
          <span v-else-if="pageAnnot.type == 'STATE'">State</span>
          <span v-else-if="pageAnnot.type == 'PROVIDER_TEXT'" style="opacity: 1;">{{ pageAnnot.data }}</span>
          <img v-else-if="pageAnnot.type == 'PROVIDER_SIGNATURE' && pageAnnot.data" :src="pageAnnot.data"
            style="opacity: 1;" />
          <img v-else-if="pageAnnot.type == 'CIRCLEBOX'" src="@/assets/pdf-editor-icons/circlebox.png" alt="Circlebox">
          <img v-else-if="pageAnnot.type == 'CHECKBOX'" src="@/assets/pdf-editor-icons/checkbox.png" alt="Checkbox">
          <div class="resize-handle" v-if="pageAnnot.type != 'CHECKBOX' && isAnnotSelected(pageAnnot)"
            @mousedown.prevent.stop="handleResizeAnnot($event, pageAnnot)"></div>
        </div>
      </div>
      <div class="button-container">
        <button class="button primary" @click="attemptSaveChanges">Save Changes</button>
        <a href="#" v-if="formInfo && formInfo.isUnderReview" style="margin-top: 10px" @click="startFormReview">Complete
          Form
          Review</a>
      </div>
    </div>
    <div class="optbar">
      <div class="opt-list">
        <div class="opt-item" :data-disabled="!transform.allowMapping">
          <div class="selected-ehr-field" v-if="!isEhrMenuOpen" @click.prevent="openEhrMenu()">
            <span class="selected-category" v-if="getCurrentEhrField()[0]">{{ getCurrentEhrField()[0] }}</span>
            <span class="selected-field">{{ getCurrentEhrField()[1] }}</span>
          </div>
          <input v-else-if="isEhrMenuOpen" type="text" class="connected-ehr-field" placeholder="Search EHR Fields"
            v-model="ehrQuery" @focus="isEhrMenuOpen = true" @blur="isEhrMenuOpen = false" @keydown.stop=""
            ref="ehrQuery">
          <div class="ehr-fields-menu" v-if="isEhrMenuOpen">
            <span style="display: block; padding: 10px" v-if="!getEhrCategories().length">0 Results Found</span>
            <div class="category" v-for="cat of getEhrCategories()" :key="cat.label">
              <div class="category-label">{{ cat.label }}</div>
              <div class="category-field" v-for="field of cat.fields" :key="field.key"
                @mousedown.prevent.stop="selectEhrField(field)">
                {{ field.label }}
              </div>
            </div>
          </div>
        </div>
        <div class="opt-item" :data-disabled="!transform.allowRequired">
          <CheckBox colorFilled="#EEE" colorLine="#000" :value="transform.required" @updateValue="updateIsRequired" />
          <label>Response Required</label>
        </div>
        <div class="opt-item" :data-disabled="!transform.allowGroup">
          <CheckBox colorFilled="#EEE" colorLine="#000" :value="transform.grouped" @updateValue="updateIsGrouped" />
          <label>Checkboxes Grouped</label>
        </div>
        <div class="opt-item" :data-disabled="!transform.allowWrap">
          <CheckBox colorFilled="#EEE" colorLine="#000" :value="transform.wrapEnabled" @updateValue="updateWrapEnabled" />
          <label>Wrap to next line</label>
        </div>
        <div class="opt-field" v-if="transform.allowProviderText">
          <label>Provider Text</label>
          <input type="text" v-model="transform.providerData" @keydown.stop="" @input="updateProviderDataInput">
        </div>
        <div class="opt-field" v-if="transform.allowSignatureType">
          <label>Signature Type</label>
          <select v-model="transform.signatureType" @change="updateSignatureType">
            <option value="signature-patient">Patient Signature</option>
            <option value="initials-patient">Patient Initials</option>
            <option value="signature-guardian">Guardian Signature</option>
            <option value="initials-guardian">Guardian Initials</option>
            <option value="signature-witness">Witness Signature</option>
            <option value="initials-witness">Witness Initials</option>
          </select>
        </div>
        <div class="opt-field" v-if="transform.allowProviderSignature">
          <label>Provider Signature</label>
          <button @click="openModal('set-signature')">Update signature</button>
        </div>
        <OptionsListTab v-if="transform.allowOptions" :options="transform.options" :locked="transform.optionsLocked"
          @updateOptions="updateOptions" />
      </div>
    </div>
    <div class="tool-shadow" v-if="activeTool && shadow.visible" :style="getShadowStyle()">

    </div>
    <transition name="modal" mode="out-in">
      <SignatureModal v-if="modal.id == 'set-signature'" @closeModal="closeModal"
        @submit-signature="updateProviderDataSignature" />
    </transition>
  </div>
</template>

<script>
import * as api from '@/api'
import TextboxIcon from '@/assets/pdf-editor-icons/textbox.png'
import DateboxIcon from '@/assets/pdf-editor-icons/datebox.png'
import CheckboxIcon from '@/assets/pdf-editor-icons/checkbox.png'
import CircleboxIcon from '@/assets/pdf-editor-icons/circlebox.png'
import SignatureIcon from '@/assets/pdf-editor-icons/signature.png'
import SelectIcon from '@/assets/pdf-editor-icons/select.png'
import PhoneIcon from '@/assets/pdf-editor-icons/phone.png'
import EmailIcon from '@/assets/pdf-editor-icons/email.png'
import ProviderIcon from '@/assets/pdf-editor-icons/provider.png'
import DropdownSharedIcon from '@/assets/pdf-editor-icons/dropdown-shared.png'
import CheckBox from '../../components/CheckBox.vue'
import SignatureModal from '@/modals/form-editor/SignatureModal.vue'
import OptionsListTab from '@/components/form-editor-shared/OptionsListTab.vue'

const ALL_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

export default {
  components: { CheckBox, SignatureModal, OptionsListTab },
  name: 'PDFFormEditorView',
  data() {
    return {
      modal: {
        id: "",
        open: false,
        data: null,
      },
      formInfo: null,
      pageImages: [],
      selectedAnnots: new Set(),
      activeTool: 'SELECT',
      emrJson: null,
      toolbar: {
        tools: [
          { id: 'SELECT', label: 'Select', icon: SelectIcon, key: 'Q', size: null },
          { id: 'TEXT', label: 'Textbox', icon: TextboxIcon, key: 'T', size: 20 },
          { id: 'NUMBER', label: 'Number', icon: TextboxIcon, key: 'N', size: 20 },
          { id: 'SSN', label: 'SSN', icon: TextboxIcon, size: 20 },
          { id: 'DATE', label: 'Date', icon: DateboxIcon, key: 'D', size: 20 },
          { id: 'PHONE', label: 'Phone', icon: PhoneIcon, key: 'P', size: 20 },
          { id: 'EMAIL', label: 'Email', icon: EmailIcon, key: 'E', size: 20 },
          { id: 'DROPDOWN', label: 'Dropdown', icon: DropdownSharedIcon, size: 20 },
          { id: 'MULTISELECT', label: 'Multi-Select', icon: DropdownSharedIcon, size: 20 },
          { id: 'STATE', label: 'State', icon: DropdownSharedIcon, size: 20 },
          { id: 'CHECKBOX', label: 'Checkbox', icon: CheckboxIcon, key: 'X', size: 24 },
          { id: 'CIRCLEBOX', label: 'Circlebox', icon: CircleboxIcon, key: 'C', size: 24 },
          { id: 'SIGNATURE', label: 'Signature', icon: SignatureIcon, key: 'S', size: 40 },
          { id: 'PROVIDER_TEXT', label: 'Prov. Text', icon: ProviderIcon, size: 20 },
          { id: 'PROVIDER_SIGNATURE', label: 'Prov. Signature', icon: ProviderIcon, size: 40 },
        ],
        x: (window.innerWidth - 1000) / 2 - 220,
        y: 20,
        grabbing: false,
        grabOffX: 0,
        grabOffY: 0,
      },
      optbar: {
        x: (window.innerWidth - 1000) / 2 - 220,
        y: 400,
        grabbing: false,
        grabOffX: 0,
        grabOffY: 0,
      },
      shadow: {
        visible: false,
        x: 0,
        y: 0,
        lastMouseX: 0,
        lastMouseY: 0,
        width: 0,
        height: 0,
        lockX: 0,
        lockY: 0
      },
      isShiftDown: false,
      isSelecting: false,
      selectionX: 0,
      selectionY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      isResizing: false,
      resizingAnnot: null,
      resizingPageEl: null,
      transform: {
        required: false,
        signatureType: 'signature-patient',
        wrapEnabled: false,
        allowWrap: false,
        allowOptions: false,
        optionsLocked: false,
        options: []
      },
      ehrQuery: '',
      isEhrMenuOpen: false
    }
  },
  mounted() {
    this.fetchFormInfo();
    this.fetchEhrMappings();
    window.addEventListener('mousemove', this.handleMouseMove);
    window.addEventListener('mouseup', this.handleMouseUp);
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  unmounted() {
    window.removeEventListener('mousemove', this.handleMouseMove);
    window.removeEventListener('mouseup', this.handleMouseUp);
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },
  watch: {
    selectedAnnots: {
      handler(newVal) {
        const annots = this.formInfo.filePages
          .flatMap(fp => fp.pageAnnotations)
          .filter(a => newVal.has(a._id));

        this.transform.allowMapping = true;
        this.transform.allowRequired = true;
        this.transform.allowGroup = true;
        this.transform.required = false;
        this.transform.grouped = false;
        this.transform.allowProviderText = true;
        this.transform.allowProviderSignature = true;
        this.transform.allowSignatureType = true;
        this.transform.providerData = '';
        this.transform.signatureType = 'signature-patient';
        this.transform.wrapEnabled = false;
        this.transform.allowWrap = true;
        this.transform.allowOptions = true;
        this.transform.optionsLocked = false;
        this.transform.options = [];

        if (annots.length < 1) {
          this.transform.allowMapping = false;
          this.transform.allowRequired = false;
          this.transform.allowProviderText = false;
          this.transform.allowProviderSignature = false;
          this.transform.allowSignatureType = false;
          this.transform.allowWrap = false;
          this.transform.allowOptions = false;
        }

        if (annots.length < 2) {
          this.transform.allowGroup = false;
        }

        for (let annot of annots) {

          // Checkboxes cannot be required
          if (annot.type == 'CHECKBOX' || annot.type == 'CIRCLEBOX') {
            this.transform.allowRequired = false;
          }

          // Following types cannot be mapped
          if (annot.type == 'CHECKBOX' || annot.type == 'CIRCLEBOX' || annot.type == 'SIGNATURE') {
            this.transform.allowMapping = false;
          }

          // If there are any required, show it as "required true"
          if (annot.optional != null && annot.optional == false) {
            this.transform.required = true;
          }

          // Check if they are grouped
          if (annot.type != 'CHECKBOX' && annot.type != 'CIRCLEBOX') {
            this.transform.allowGroup = false;
          }

          // Check if they are provider fields
          if (annot.type != 'PROVIDER_TEXT') {
            this.transform.allowProviderText = false;
          } else {
            if (this.transform.providerData == '') {
              this.transform.providerData = annot.data;
            } else if (annot.data != this.transform.providerData) {
              this.transform.providerData = 'Multiple values'
            }
          }

          if (annot.type != 'PROVIDER_SIGNATURE') {
            this.transform.allowProviderSignature = false;
          }

          // Check if they are signature fields
          if (annot.type != 'SIGNATURE') {
            this.transform.allowSignatureType = false;
          } else {
            // Set the signature type from the annotation if it exists
            if (this.transform.signatureType == 'signature-patient' && annot.signatureType) {
              this.transform.signatureType = annot.signatureType;
            } else if (annot.signatureType && annot.signatureType != this.transform.signatureType) {
              this.transform.signatureType = 'signature-patient'; // Reset to default if multiple different values
            }
          }

          // Set wrap if any TEXT annotation has it
          if (annot.type == 'TEXT' && annot.wrapEnabled) {
            this.transform.wrapEnabled = true;
          }

          // Only allow wrap for TEXT fields
          if (annot.type != 'TEXT') {
            this.transform.allowWrap = false;
          }

          // Only allow options for DROPDOWN and MULTISELECT (not STATE - it has hardcoded options)
          if (annot.type != 'DROPDOWN' && annot.type != 'MULTISELECT') {
            this.transform.allowOptions = false;
          } else {
            // Set options from the first annotation with options (make a copy)
            if (this.transform.options.length === 0 && annot.options) {
              this.transform.options = [...annot.options];
            }

            // Lock options if field is mapped to an EHR field (not doNotImport or part fields)
            const key = annot.key;
            if (key && !key.startsWith('doNotImport') && !key.startsWith('part')) {
              this.transform.optionsLocked = true;
            }
          }
        }

        if (this.transform.allowGroup) {
          this.transform.grouped = true;
          for (let i = 1; i < annots.length; i++) {
            const c = annots[i];
            const p = annots[i - 1];
            if (!c.group || !c.group.id || !p.group || !p.group.id || c.group.id != p.group.id) {
              this.transform.grouped = false;
            }
          }
        }

      },
      deep: true
    }
  },
  methods: {
    async fetchFormInfo() {
      const formId = this.$route.params.id;
      try {
        this.formInfo = await api.latestVersion(formId);

        if (!this.formInfo.filePages || this.formInfo.filePages.length == 0) {
          this.formInfo.filePages = this.formInfo.filePagePaths.map((_, idx) => ({
            page: idx + 1,
            pageAnnotations: []
          }))
        }

        for (let page of this.formInfo.filePages) {
          for (let annot of page.pageAnnotations) {
            annot._id = this.generateRandomId('internal', 10)
          }
        }

        this.loadPageImages();
      } catch (err) {
        alert('Failed to fetch form info');
      }
    },
    async loadPageImages() {
      this.pageImages = await Promise.all(this.formInfo.filePagePaths
        .map(path => new Promise((resolve, reject) => {
          const image = new Image();
          image.src = process.env.VUE_APP_PUBLIC_IMAGES + path;
          image.crossOrigin = 'Anonymous'
          image.onload = () => resolve(image);
          image.onerror = (err) => reject(err);
        }))
      );
    },
    async attemptSaveChanges() {
      try {

        const ROW_THRESH = 0.01;

        const filePages = this.formInfo.filePages.map(page => {
          return {
            ...page,
            pageAnnotations: page.pageAnnotations
              .sort((a, b) => {
                // Sort correctly so tab is nice
                if (Math.abs(a.y - b.y) < ROW_THRESH) {
                  return a.x - b.x;
                }
                return b.y - a.y;
              })
              .filter(annot => {
                if (annot.width == null || annot.width < 0.001) {
                  return false;
                }
                if (annot.height == null || annot.height < 0.001) {
                  return false;
                }

                return true;
              })
              .map((annot) => {
                if (annot._id) {
                  delete annot['_id'];
                }

                // Bound to page
                if (annot.width > 1) annot.width = 1;
                if (annot.height > 1) annot.height = 1;
                if (annot.x < 0) annot.x = 0;
                if (annot.y < 0) annot.y = 0;
                if (annot.x + annot.width > 1) annot.x = 1 - annot.width;
                if (annot.y + annot.height > 1) annot.y = 1 - annot.height;
                return annot;
              })
          }
        })

        await api.updateFormAnnotations(this.formInfo.id, filePages);
        this.$router.push(`/forms`)
      } catch (err) {
        console.error(err);
      }
    },
    async fetchEhrMappings() {
      try {
        const res = await fetch(process.env.VUE_APP_API + '/static/emrs/practicefusion.json');
        const text = await res.text();
        this.emrJson = JSON.parse(text);
      } catch (err) {
        console.error('Failed to fetch EHR JSON')
      }
    },
    async startFormReview() {
      if (confirm('Please only proceed if you are authorized as a form reviewer')) {
        const name = prompt('Enter your name:');
        if (name) {
          await api.reviewForm(this.formInfo.id, name);
          await this.attemptSaveChanges();
        }
      }
    },
    getPageStyle(pageImage) {
      return {
        aspectRatio: pageImage.width / pageImage.height,
        backgroundImage: `url(${pageImage.src})`
      }
    },
    getPageAnnots(pageIndex) {
      const filePages = this.formInfo.filePages;
      if (!filePages) return [];

      const filePage = filePages[pageIndex];
      if (!filePage) return [];

      return filePage.pageAnnotations;
    },
    getAnnotStyle(annot) {
      const style = {
        left: (annot.x * 100) + '%',
        bottom: (annot.y * 100) + '%',
        width: (annot.width * 100) + '%',
        height: (annot.height * 100) + '%'
      }

      if (annot.type == 'PROVIDER_TEXT' || annot.type == 'PROVIDER_SIGNATURE') {
        style.backgroundColor = '#2df9ef22'
      }

      return style;
    },
    recomputeShadow() {
      const sh = this.shadow;
      let cx = sh.lastMouseX;
      let cy = sh.lastMouseY;

      if (this.isShiftDown) {
        const dx = Math.abs(cx - sh.lockX);
        const dy = Math.abs(cy - sh.lockY);
        if (dx > dy) {
          cy = sh.lockY;
        } else {
          cx = sh.lockX;
        }
      }

      if (this.activeTool && this.activeTool != 'SELECT') {

        const tool = this.toolbar.tools.find(t => t.id == this.activeTool);
        if (!tool) return;

        switch (this.activeTool) {
          case 'CHECKBOX':
          case 'CIRCLEBOX':
            sh.x = cx - tool.size / 2;
            sh.y = cy - tool.size / 2;
            sh.width = tool.size;
            sh.height = tool.size;
            break;
          case 'SIGNATURE':
            sh.x = cx - tool.size / 4;
            sh.y = cy - tool.size / 2;
            sh.width = tool.size * 2;
            sh.height = tool.size;
            break;
          default:
            sh.x = cx - tool.size / 4;
            sh.y = cy - tool.size / 2;
            sh.width = tool.size * 2;
            sh.height = tool.size;
            break;
        }

        sh.visible = true;
      } else if (this.activeTool == 'SELECT' && this.isSelecting) {

        if (cx > this.selectionX) {
          sh.x = this.selectionX;
          sh.width = cx - this.selectionX;
        } else {
          sh.x = cx;
          sh.width = this.selectionX - cx;
        }

        if (cy > this.selectionY) {
          sh.y = this.selectionY;
          sh.height = cy - this.selectionY;
        } else {
          sh.y = cy;
          sh.height = this.selectionY - cy;
        }


        sh.visible = true;
      } else {
        sh.visible = false;
      }
    },
    getShadowStyle() {
      const style = {
        left: this.shadow.x + 'px',
        top: this.shadow.y + 'px',
        width: this.shadow.width + 'px',
        height: this.shadow.height + 'px'
      }

      if (this.activeTool == 'PROVIDER_TEXT' || this.activeTool == 'PROVIDER_SIGNATURE') {
        style.background = '#2df9ef'
      }

      return style;
    },
    handleMouseMove(event) {

      // Recompute shadow
      const sh = this.shadow;
      sh.lastMouseX = event.clientX;
      sh.lastMouseY = event.clientY;
      this.recomputeShadow();

      // Dragging
      if (this.isDragging) {
        const dx = event.clientX - this.dragStartX;
        const dy = event.clientY - this.dragStartY;
        const annots = this.$el.querySelectorAll('.page-annot');
        for (let annot of annots) {
          const id = annot.getAttribute('data-id');
          if (!this.selectedAnnots.has(id)) continue;
          annot.style.transform = `translate(${dx}px, ${dy}px)`;
          annot.style.zIndex = '9999';
        }
      }

      // Resizing
      if (this.isResizing) {
        this.resizingAnnotEl.style.transition = 'none';
        const bb = this.resizingPageEl.getBoundingClientRect();
        const a = this.resizingAnnot;
        const prevWidth = a.width;
        const prevHeight = a.height;
        const x = a.x * bb.width + bb.left;
        const xc = event.clientX;
        a.width = (xc - x) / bb.width;

        if (a.type == 'PROVIDER_SIGNATURE') {
          const newHeight = prevHeight * (a.width / prevWidth);
          a.height = newHeight;
        }
      }
    },
    handleMouseUp() {
      const sh = this.shadow;
      if (this.activeTool == 'SELECT' && this.isSelecting) {
        this.isSelecting = false;
        sh.visible = false;

        const annots = this.$el.querySelectorAll('.page-annot');
        this.selectedAnnots.clear();
        for (let annot of annots) {
          const bb = annot.getBoundingClientRect();
          if (bb.left < sh.x || bb.right > sh.x + sh.width) continue;
          if (bb.top < sh.y || bb.bottom > sh.y + sh.height) continue;
          this.selectedAnnots.add(annot.getAttribute('data-id'));
        }

        sh.width = 0;
        sh.height = 0;
      }

      if (this.isDragging) {
        this.isDragging = false;

        const annots = this.$el.querySelectorAll('.page-annot');
        for (let annotEl of annots) {
          const id = annotEl.getAttribute('data-id');
          if (!this.selectedAnnots.has(id)) continue;

          const annot = this.formInfo.filePages
            .flatMap(fp => fp.pageAnnotations)
            .find(a => a._id == id);

          if (annot) {
            const parentBB = annotEl.parentElement.getBoundingClientRect();
            const bb = annotEl.getBoundingClientRect();
            annot.x = (bb.x - parentBB.x) / parentBB.width;
            annot.y = 1 - (bb.y - parentBB.y + bb.height) / parentBB.height;
          }

          annot.x = Math.max(0, Math.min(annot.x, 1 - annot.width));
          annot.y = Math.max(0, Math.min(annot.y, 1 - annot.height));
          annotEl.style.transform = '';
          annotEl.style.zIndex = '';
        }
      }

      if (this.isResizing) {
        this.isResizing = false;
        this.resizingAnnotEl.style.transition = '';
      }
    },
    handlePageClick(event, pageIndex) {

      if (this.isEhrMenuOpen) {
        this.isEhrMenuOpen = false;
        const ehrQueryRef = this.$refs.ehrQuery;
        if (ehrQueryRef) ehrQueryRef.blur();
      }

      if (this.activeTool && this.activeTool != 'SELECT') {
        const el = event.currentTarget;
        const bb = el.getBoundingClientRect();

        let sh = this.shadow;
        let x = (sh.x - bb.left) / bb.width;
        let y = (bb.top + bb.height - sh.y - sh.height) / bb.height;
        let w = sh.width / bb.width;
        let h = sh.height / bb.height;
        const newAnnot = {
          _id: this.generateRandomId('internal', 10),
          key: this.generateRandomId('doNotImport'),
          type: this.activeTool,
          x: x,
          y: y,
          width: w,
          height: h,
          optional: true
        }

        // Initialize options for dropdown/multiselect/state fields
        if (this.activeTool === 'STATE') {
          newAnnot.options = ALL_STATES;
        } else if (this.activeTool === 'DROPDOWN' || this.activeTool === 'MULTISELECT') {
          newAnnot.options = ['Option 1', 'Option 2', 'Option 3'];
        }

        const filePages = this.formInfo.filePages;
        const filePage = filePages[pageIndex];
        filePage.pageAnnotations.push(newAnnot)

        this.$nextTick(() => {
          if (['TEXT', 'DATE', 'PHONE', 'SIGNATURE', 'EMAIL', 'NUMBER', 'SSN', 'DROPDOWN', 'MULTISELECT', 'STATE', 'PROVIDER_TEXT'].includes(this.activeTool)) {
            const img = this.pageImages[pageIndex];
            const cnv = document.createElement('canvas');
            const ctx = cnv.getContext('2d');

            const clickX = Math.floor((sh.lastMouseX - bb.left) * (img.width / bb.width));
            const ix = 0;
            const iw = img.width;
            const ih = Math.floor(newAnnot.height * img.height) + 20; // Put 20 pixels on the bottom for good measure
            const iy = Math.floor((sh.y - bb.top) * (img.height / bb.height));

            cnv.width = iw;
            cnv.height = ih;
            ctx.drawImage(img, ix, iy, iw, ih, 0, 0, iw, ih);
            const imageData = ctx.getImageData(0, 0, iw, ih);
            const data = imageData.data;

            let startCol = clickX;
            let endCol = clickX;

            // Calculate the position of the line (using first dark spot), starting from middle
            let lineRow = 0;
            const hh = Math.floor(ih / 2);
            for (let i = 0; i < hh; i++) {

              // Check UP
              const rowUp = hh - i;
              const indexUp = (rowUp * iw + clickX) * 4
              const rUp = data[indexUp];
              const gUp = data[indexUp + 1];
              const bUp = data[indexUp + 2];
              const brightnessUp = (rUp + gUp + bUp) / 3;
              if (brightnessUp < 150) {
                lineRow = rowUp;
                ctx.fillRect(clickX - 10, rowUp - 5, 20, 10);
                break;
              }

              // Check DOWN
              const rowDown = hh + i;
              const indexDown = (rowDown * iw + clickX) * 4;
              const rDown = data[indexDown];
              const gDown = data[indexDown + 1];
              const bDown = data[indexDown + 2];
              const brightnessDown = (rDown + gDown + bDown) / 3;
              if (brightnessDown < 150) {
                lineRow = rowDown;
                ctx.fillRect(clickX - 10, rowDown - 5, 20, 10);
                break;
              }
            }

            // Find the start point
            for (let col = clickX; col >= 0; col--) {
              const index = (lineRow * iw + col) * 4;
              const r = data[index];
              const g = data[index + 1];
              const b = data[index + 2];
              const brightness = (r + g + b) / 3;

              // average line is brighter than 100? stop here
              if (brightness > 220) {
                startCol = col;
                break;
              }
            }

            // Find the end point
            for (let col = clickX; col < iw; col++) {
              const index = (lineRow * iw + col) * 4;
              const r = data[index];
              const g = data[index + 1];
              const b = data[index + 2];
              const brightness = (r + g + b) / 3;

              // average line is brighter than 100? stop here
              if (brightness > 220) {
                endCol = col;
                break;
              }
            }

            // Update the annotation
            let newW = (endCol - startCol - 20) / img.width;
            if (newW > newAnnot.width) {
              newAnnot.y -= lineRow / img.height - newAnnot.height;
              newAnnot.x = (startCol + 10) / img.width;
              newAnnot.width = (newW);
            }
          }

          if (this.activeTool == 'SIGNATURE') {
            newAnnot.optional = false;
          }
        })
      }

      if (this.activeTool == 'SELECT') {
        if (api.store.stampAnnotation) {
          const el = event.currentTarget;
          const bb = el.getBoundingClientRect();
          const clone = structuredClone(api.store.stampAnnotation);
          clone._id = this.generateRandomId('internal', 10);
          if (clone.key.startsWith('doNotImport')) {
            clone.key = this.generateRandomId('doNotImport', 10);
          }
          clone.x = (event.clientX - bb.left) / bb.width - clone.width / 2;
          clone.y = (bb.top + bb.height - event.clientY) / bb.height - clone.height / 2;
          clone.x = Math.max(0, Math.min(clone.x, 1 - clone.width));
          clone.y = Math.max(0, Math.min(clone.y, 1 - clone.height));
          this.formInfo.filePages[pageIndex].pageAnnotations.push(clone);
          this.selectedAnnots.clear();
          this.selectedAnnots.add(clone._id);
          return;
        }

        if (!this.isSelecting) {
          this.selectedAnnots.clear();
          this.isSelecting = true;
          this.selectionX = event.clientX;
          this.selectionY = event.clientY;
        }
      }

    },
    handleClickAnnot(event, annot) {
      const annotKey = annot._id;

      if (event.button == 2) {
        event.preventDefault();
        event.stopPropagation();

        const idsToDuplicate = this.selectedAnnots;
        const duplicatedIds = new Set();

        for (let filePage of this.formInfo.filePages) {
          for (let annot of filePage.pageAnnotations) {
            if (idsToDuplicate.has(annot._id)) {
              // Duplicate it
              const newAnnot = {
                _id: this.generateRandomId('internal', 10),
                key: this.generateRandomId('doNotImport'),
                type: annot.type,
                x: annot.x,
                y: annot.y,
                width: annot.width,
                height: annot.height,
                optional: annot.optional,
                background: annot.background,
                wrapEnabled: annot.wrapEnabled,
                signatureType: annot.signatureType,
                data: annot.data,
                options: annot.options ? [...annot.options] : undefined
              }
              // Copy group if it exists
              if (annot.group) {
                newAnnot.group = { ...annot.group };
              }
              filePage.pageAnnotations.push(newAnnot);
              duplicatedIds.add(newAnnot._id);
            }
          }
        }

        this.selectedAnnots = duplicatedIds;
        this.dragStartX = event.clientX;
        this.dragStartY = event.clientY;
        this.isDragging = true;
        return;

      }

      if (this.isShiftDown) {
        if (this.selectedAnnots.has(annotKey)) {
          this.selectedAnnots.delete(annotKey);
        } else {
          this.selectedAnnots.add(annotKey);
        }
      } else if (!this.selectedAnnots.has(annotKey)) {
        this.selectedAnnots.clear();
        this.selectedAnnots.add(annotKey);
        if (annot.group) {
          this.formInfo.filePages
            .flatMap(fp => fp.pageAnnotations)
            .filter(a => a._id != annotKey && a.group && a.group.id == annot.group.id)
            .forEach(a => this.selectedAnnots.add(a._id));
        }
      } else {
        this.dragStartX = event.clientX;
        this.dragStartY = event.clientY;
        this.isDragging = true;
      }
    },
    handleResizeAnnot(event, annot) {
      const handleEl = event.currentTarget;
      const annotEl = handleEl.parentElement;
      const pageEl = annotEl.parentElement;

      this.isResizing = true;
      this.resizingAnnot = annot;
      this.resizingAnnotEl = annotEl;
      this.resizingPageEl = pageEl;
    },
    handleKeyDown(event) {
      const key = event.key.toUpperCase();

      // Ignore keyboard shortcuts when typing in input fields
      const target = event.target;
      if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) {
        return;
      }

      if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        // Prevent the default save action
        event.preventDefault();
        // Download PDF instead
        this.printForm();
        return;
      }

      if (key == 'SHIFT' && !this.isShiftDown) {
        const sh = this.shadow;
        sh.lockX = sh.lastMouseX;
        sh.lockY = sh.lastMouseY;
        this.isShiftDown = true;
      }

      if (key == 'ESCAPE') {
        api.store.stampAnnotation = null;
      }

      if (key == 'BACKSPACE' || key == 'DELETE') {
        for (let filePage of this.formInfo.filePages) {
          filePage.pageAnnotations = filePage.pageAnnotations.filter(annot => {
            return !this.selectedAnnots.has(annot._id)
          });
        }
        this.selectedAnnots.clear();
      }

      if (key == 'G' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        event.stopPropagation();

        const annots = this.formInfo.filePages
          .flatMap(fp => fp.pageAnnotations)
          .filter(a => this.selectedAnnots.has(a._id))

        if (this.transform.grouped) {
          for (let annot of annots) {
            if (annot.type == 'CHECKBOX' || annot.type == 'CIRCLEBOX') {
              annot.group = undefined;
            }
          }
          this.transform.grouped = false;
        } else {
          let randomId = 'GRP';
          for (let i = 0; i < 10; i++) {
            randomId += Math.floor(Math.random() * 10);
          }
          for (let annot of annots) {
            if (annot.type == 'CHECKBOX' || annot.type == 'CIRCLEBOX') {
              annot.group = {
                id: randomId,
                rule: 'FILL_ONE'
              }
            }
          }
          this.transform.grouped = true;
        }
      }

      if (key == 'C' && event.shiftKey && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        const annot = this.formInfo.filePages
          .flatMap(fp => fp.pageAnnotations)
          .find(a => this.selectedAnnots.has(a._id));
        if (annot) {
          api.store.stampAnnotation = structuredClone(annot);
        }
        return;
      }

      if (key == 'C' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();
        api.store.clipboard = [];

        for (let page of this.formInfo.filePages) {
          const pageCopy = [];

          for (let annot of page.pageAnnotations) {
            if (this.selectedAnnots.has(annot._id)) {
              pageCopy.push(structuredClone(annot));
            }
          }

          api.store.clipboard.push(pageCopy);
        }

        return;
      }

      if (key == 'V' && (event.ctrlKey || event.metaKey)) {
        if (!api.store.clipboard) return;

        const groupMappings = new Map();

        this.selectedAnnots = new Set();
        for (let i = 0; i < this.formInfo.filePages.length; i++) {
          if (i >= api.store.clipboard.length) break;
          const clones = api.store.clipboard[i];
          for (let clone of clones) {
            clone = structuredClone(clone);
            clone._id = this.generateRandomId('internal', 10)
            if (clone.key.startsWith('doNotImport')) {
              clone.key = this.generateRandomId('doNotImport', 10);
            }
            if (clone.group && clone.group.id) {
              if (!groupMappings.has(clone.group.id)) {
                let randomId = 'GRP';
                for (let i = 0; i < 10; i++) {
                  randomId += Math.floor(Math.random() * 10);
                }
                groupMappings.set(clone.group.id, randomId);
                clone.group.id = randomId;
              } else {
                clone.group.id = groupMappings.get(clone.group.id);
              }
            }
            this.formInfo.filePages[i].pageAnnotations.push(clone);
            this.selectedAnnots.add(clone._id)
          }
        }
      }

      if (key.startsWith('ARROW')) {
        event.preventDefault();

        // For each selected annotation
        const annots = this.$el.querySelectorAll('.page-annot');
        for (let annotEl of annots) {
          const id = annotEl.getAttribute('data-id');
          if (!this.selectedAnnots.has(id)) continue;

          // Find the annot object
          const annot = this.formInfo.filePages
            .flatMap(fp => fp.pageAnnotations)
            .find(a => a._id == id);
          if (!annotEl) return;

          // Move it
          const distance = event.shiftKey ? 10 : 2;
          const parentBB = annotEl.parentElement.getBoundingClientRect();

          if (key == 'ARROWDOWN') {
            annot.y -= distance / parentBB.height;
          }

          if (key == 'ARROWUP') {
            annot.y += distance / parentBB.height;
          }

          if (key == 'ARROWRIGHT') {
            annot.x += distance / parentBB.width;
          }

          if (key == 'ARROWLEFT') {
            annot.x -= distance / parentBB.width;
          }

          annot.x = Math.max(0, Math.min(annot.x, 1 - annot.width));
          annot.y = Math.max(0, Math.min(annot.y, 1 - annot.height));
        }
      }

      const tool = this.toolbar.tools.find(t => t.key == key);
      if (tool) {
        this.activeTool = tool.id;
        this.recomputeShadow();
      }
    },
    handleKeyUp(event) {
      const key = event.key.toUpperCase();
      if (key == 'SHIFT') {
        this.isShiftDown = false;
      }
    },
    generateRandomId(prefix, length = 12) {
      let randomId = prefix;

      for (let i = 0; i < length; i++) {
        randomId += Math.floor(Math.random() * 10);
      }

      return randomId;
    },
    isAnnotSelected(annot) {
      return this.selectedAnnots.has(annot._id);
    },
    updateIsRequired(value) {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        annot.optional = !value;
      }
    },
    updateIsGrouped(value) {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      if (value) {
        let randomId = 'GRP';
        for (let i = 0; i < 10; i++) {
          randomId += Math.floor(Math.random() * 10);
        }
        for (let annot of annots) {
          if (annot.type == 'CHECKBOX' || annot.type == 'CIRCLEBOX') {
            annot.group = {
              id: randomId,
              rule: 'FILL_ONE'
            }
          }
        }
      } else {
        for (let annot of annots) {
          if (annot.type == 'CHECKBOX' || annot.type == 'CIRCLEBOX') {
            annot.group = null;
          }
        }
      }
    },
    updateWrapEnabled(value) {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        if (annot.type == 'TEXT') {
          annot.wrapEnabled = value;
        }
      }
    },
    updateOptions(options) {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        // Only update DROPDOWN and MULTISELECT (not STATE - it has hardcoded options)
        if (annot.type == 'DROPDOWN' || annot.type == 'MULTISELECT') {
          annot.options = options;
        }
      }
    },
    updateProviderDataInput() {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        annot.data = this.transform.providerData;
      }
    },
    updateProviderDataSignature(base64) {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        annot.data = base64;
      }

      this.closeModal();
    },
    updateSignatureType() {
      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        if (annot.type == 'SIGNATURE') {
          annot.signatureType = this.transform.signatureType;
        }
      }
    },
    getEhrCategories() {
      if (!this.emrJson) return [];

      const categories = [];

      for (let field of this.emrJson.fields) {
        if (!field.scope.includes('FILE')) continue;

        // Filter
        if (this.ehrQuery && (!field.label.toLowerCase().includes(this.ehrQuery.toLowerCase()) &&
          !field.category.toLowerCase().includes(this.ehrQuery.toLowerCase()))) {
          continue;
        }

        const catIdx = categories.findIndex(cat => cat.label == field.category);
        if (catIdx == -1) {
          categories.push({ label: field.category, fields: [field] });
        } else {
          categories[catIdx].fields.push(field);
        }
      }

      return categories;
    },
    selectEhrField(field) {
      if (!this.formInfo || !this.formInfo.filePages) return;

      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      for (let annot of annots) {
        // Update the annotation key
        if (field.unique) {
          annot.key = field.key + this.generateRandomNonce();
        } else {
          annot.key = field.key;
        }

        // Update the annotation type
        if (field.type != null) {
          annot.type = field.type;
        }

        // Required flag
        if (field.optional != null) {
          annot.optional = field.optional;
        }

        // Update options
        if (field.options != null) {
          annot.options = field.options;
        } else {
          annot.options = undefined;
        }
      }

      this.isEhrMenuOpen = false;
    },
    getCurrentEhrField() {
      if (!this.formInfo || !this.formInfo.filePages) {
        return [null, 'Select an EHR field']
      }

      const annots = this.formInfo.filePages
        .flatMap(fp => fp.pageAnnotations)
        .filter(a => this.selectedAnnots.has(a._id));

      if (annots.length == 0) {
        return [null, 'Select an EHR field']
      }

      const set = new Set(annots.map(annot => this.getFieldLabelForKey(annot.key)));
      if (set.size > 1) {
        return [null, set.size + ' fields']
      }

      return [
        this.getCategoryLabelForKey(annots[0].key),
        this.getFieldLabelForKey(annots[0].key)
      ]
    },
    getFieldLabelForKey(key) {
      if (!this.emrJson) return;

      for (let field of this.emrJson.fields) {
        if (key.startsWith(field.key)) {
          return field.label;
        }
      }

      return 'Not Found'
    },
    getCategoryLabelForKey(key) {
      if (!this.emrJson) return;

      for (let field of this.emrJson.fields) {
        if (key.startsWith(field.key)) {
          return field.category;
        }
      }

      return 'Not Found'
    },
    openEhrMenu() {
      this.isEhrMenuOpen = true;

      this.$nextTick(() => {
        const ehrQueryRef = this.$refs.ehrQuery;
        if (ehrQueryRef) {
          ehrQueryRef.focus();
          ehrQueryRef.select();
        }
      })
    },
    generateRandomNonce(length = 10) {
      let id = "";
      for (let i = 0; i < length; i++) {
        id += Math.floor(Math.random() * 10);
      }
      return id;
    },
    shouldShowKey(key) {
      if (!key) return false;
      if (!this.emrJson) return false;
      if (key.startsWith('doNotImport')) return false;
      return true;
    },
    openModal(id, data) {
      this.modal = {
        open: true,
        id: id,
        data: data,
      };
    },
    closeModal() {
      this.modal = {
        open: false,
        id: "",
        data: null,
      };
    },
    async printForm() {
      try {
        this.isPrinting = true;
        const blob = await api.printForm(this.formInfo.id);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.download = `${this.form.name}.pdf`
        a.href = url;
        a.click();
        window.URL.revokeObjectURL(url);

      } catch (err) {
        console.error(err);
      } finally {
        this.isPrinting = false;
      }
    }
  }
}
</script>

<style scoped>
.full {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
}

.form-page {
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
}

.form-pages {
  padding: 20px;
  width: 100%;
  height: 100%;
  max-width: 1000px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;
}

.page-annot {
  position: absolute;
  background: #742df922;
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
  transition: width ease-in-out 0.1s;
  border-radius: 2px;
  overflow: hidden;
}

.page-annot span {
  white-space: nowrap;
  user-select: none;
  pointer-events: none;
  opacity: 0.3;
}

.page-annot img {
  user-select: none;
  pointer-events: none;
  width: 100%;
  height: 100%;
  display: block;
  opacity: 0.3;
}

.page-annot:hover {
  box-shadow: 0px 0px 4px #00000066;
}

.page-annot[data-selected="true"] {
  outline: 2px dashed green;
  box-shadow: inset 0px 0px 0px 250px #00FF0055;
  cursor: grab;
}

.page-annot[data-required="true"]::after {
  content: '*';
  position: absolute;
  top: 2px;
  right: 2px;
  color: red;
}

.resize-handle {
  z-index: 10;
  position: absolute;
  top: 0;
  right: 0px;
  width: 5px;
  height: 100%;
  background: #00800055;
  cursor: ew-resize;
}

/* Toolbar */

.toolbar {
  width: 250px;
  flex-shrink: 0;
  background: #FFF;
  box-shadow: 0px 2px 8px #00000022;
  overflow: hidden;
  position: relative;
  z-index: 1000;
}

.toolbar-grab {
  cursor: grab;
  width: 100%;
  height: 30px;
  background: #EEE;
  border-bottom: 1px solid #CCC;
}

.tool-list {
  padding: 15px;
}

.tool {
  padding: 15px;
  display: flex;
  gap: 15px;
  border-radius: 5px;
  user-select: none;
}

.tool:hover {
  cursor: pointer;
  background: #F5F5F5;
}

.tool[data-active="true"] {
  background: #e0d8ff;
  outline: 2px solid #8877c0;
}

.tool .icon {
  width: 20px;
  height: 20px;
  display: block;
}

.tool .name {
  flex: 1;
}

.tool .key {
  width: 20px;
  height: 20px;
  border: 1px solid #00000022;
  text-align: center;
  background: #FFF;
}

.tool-shadow {
  position: fixed;
  background: #742df9;
  opacity: 0.2;
  width: 200px;
  height: 20px;
  pointer-events: none;
}

canvas {
  width: 100%;
}

.tool-size {
  padding: 0;
  width: 20px;
  background: none;
  border: none;
  background: #FFF;
  text-align: center;
  font-size: 12px;
  border-radius: 2px;
}

.button-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.button.primary {
  width: auto;
  padding: 15px 25px;
}

/* Opt Bar */

.optbar {
  width: 250px;
  flex-shrink: 0;
  height: 100%;
  background: #FFF;
  box-shadow: 0px 2px 8px #00000022;
  overflow: hidden;
  position: relative;
  z-index: 1000;
}

.opt-list {
  padding: 15px;
}

.optbar-grab {
  cursor: grab;
  width: 100%;
  height: 30px;
  background: #EEE;
  border-bottom: 1px solid #CCC;
}

.opt-item {
  position: relative;
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px;
}

.opt-item[data-disabled="true"] {
  opacity: 0.2;
  pointer-events: none;
}

.opt-field {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 10px;
}

.opt-field label {
  font-size: 12px;
  text-transform: uppercase;
  color: #999;
}

.opt-field button {
  width: 100%;
  padding: 10px;
  gap: 3px;
  background: #F5F5F5;
  border: 1px solid #DDD;
  border-radius: 3px;
  cursor: pointer;
  font-size: 16px;
  text-align: left;
}

.opt-field input {
  width: 100%;
  padding: 10px;
  gap: 3px;
  background: #F5F5F5;
  border: 1px solid #DDD;
  border-radius: 3px;
  font-size: 16px;
}

.opt-field select {
  width: 100%;
  padding: 10px;
  gap: 3px;
  background: #F5F5F5;
  border: 1px solid #DDD;
  border-radius: 3px;
  cursor: pointer;
  font-size: 16px;
}

/* EHR Field */

.connected-ehr-field {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: none;
  background: #F5F5F5;
  outline: 1px solid #DDD;
  border-radius: 3px;
}

.ehr-fields-menu {
  position: absolute;
  top: 100%;
  left: 0px;
  width: 100%;
  max-height: calc(100vh - 100px);
  background: #FFF;
  box-shadow: 0px 0px 8px #00000022;
  z-index: 1000;
  overflow-y: auto;
  border: 1px solid #CCC;
  border-radius: 10px;
}

.category-label {
  padding: 10px;
  background: #e0d8ff;
}

.category-field {
  padding: 10px;
}

.category-field:hover {
  background: #F5F5F5;
  cursor: pointer;
}

.selected-category {
  font-size: 12px;
  text-transform: uppercase;
  color: #999;
}

.selected-ehr-field {
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  background: #F5F5F5;
  border: 1px solid #DDD;
  border-radius: 3px;
  cursor: pointer;
}
</style>